import { LocaleMessages } from "./types";

const en: LocaleMessages = {
  // ヘッダーメニュー
  header: {
    home: 'Home',
    profileCV: 'Profile & CV',
    profileCVShort: 'Profile',
    publications: 'Publications',
    works: 'Works'
  },
  // サブヘッダー
  subheader: {
    home: 'Home',
    profileCV: 'Profile & Curriculum Vitae (CV)',
    publications: 'Publications',
    works: 'Works',
    computerSystem2025: 'Computer System (2025)'
  },
  // フッター
  footer: {
    copyright: '© 2026 TOMIOKA Rio'
  },
  themeSwitch: {
    switchToGray: 'Switch to gray theme',
    switchToBlue: 'Switch to blue theme',
    currentBlue: 'Blue',
    currentGray: 'Gray'
  },
  // 言語切り替えボタン
  languageSwitch: {
    switchTo: 'Switch to Japanese'
  },
  common: {
    loading: 'Loading...',
    back: 'Back',
    backToWorks: '← Back to Works'
  },
  publications: {
    year: 'Year',
    authorship: 'Authorship',
    type: 'Type',
    review: 'Review',
    resetFilters: 'Reset Filters',
    sortByType: 'By type',
    sortByChronological: 'By year',
    showAbstract: 'Show abstract',
    hideAbstract: 'Hide abstract',
    abstractLabel: 'Abstract'
  }
};

export default en;
